import fetchApi from './fetch'

export const getEventsApi = params => fetchApi.get('event', { params })
export const getEventApi = instanceId =>
  fetchApi.get(`event/instance/${instanceId}`)
export const updateEventApi = body => fetchApi.patch('event', body)
export const updateEventInstanceApi = (id, body) =>
  fetchApi.patch(`event/instance/${id}`, body)
